<template>
    <div class="flex items-center justify-between">
        <div class="flex font-medium text-black dark:text-slate-200">
            <img :src="props.option.icon" alt="icon" style="width: 20px; height: 20px" class="mr-2">
            <span>{{ props.option.title }}</span>
        </div>
        <div class="flex font-medium text-black dark:text-slate-200">
            <span>{{ props.option.amount_formatted }}</span>
        </div>
    </div>
    <div class="flex items-center justify-between mt-1">
        <div class="flex dark:text-slate-500">
            <span>{{ $t('min.') }} {{ props.option.min_amount_formatted }}</span>
        </div>
        <div class="flex flex-col items-end">
            <div v-if="$page.props.currency.value !== props.option.method_currency.value" class="mb-1">
                ≈ {{ props.option.currency_amount_formatted }}
            </div>
            <div :class="props.option.value === 'blain-pay-usdt-ton-telegram' ? 'text-green-500' : 'text-slate-500 dark:text-slate-400'"
            >{{ props.option.commission_formatted }}
            </div>

        </div>
    </div>
</template>
<script>
export default {
    name: 'PaymentMethod',
    props: {
        props: {}
    }
}
</script>

<style src="./style.css"></style>
